import { action } from 'satcheljs/lib/legacy';

export default action('launchSuiteHelpPane')(function launchSuiteHelpPane() {
    (window as any).O365Shell.FlexPane.OpenFlexPaneForProvider('OwaHelp');
});
